module.exports = __webpack_public_path__ + "img/40_38_064_990.4b27520c.jpg";